import { api } from "../../../services/api";

export const enviarCorreo = async (to, subject, html) => {
    try {
        const response = await api.enviarCorreo({
            to: to,
            subject: subject,
            html: html,
        });
        if (response.success) {
            return response;
        } else {
            throw new Error(response.message);
        }
    } catch (error) {
        console.error("Error al enviar correo:", error.message);
        throw error;
    }
};